import React, { useEffect, useRef, useState } from 'react';

// Small dependency-free count-up: animates from 0 to `value` once on mount
// or whenever `value` changes. Falls back instantly for non-numeric values
// (e.g. the '—' placeholder shown while data hasn't loaded).
const CountUp = ({ value, duration = 900, suffix = '' }) => {
  const [display, setDisplay] = useState(0);
  const frame = useRef();

  useEffect(() => {
    const numeric = typeof value === 'number' ? value : parseFloat(value);
    if (Number.isNaN(numeric)) {
      setDisplay(null);
      return undefined;
    }
    const start = performance.now();
    const from = 0;

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(from + (numeric - from) * eased);
      if (progress < 1) frame.current = requestAnimationFrame(tick);
    };
    frame.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame.current);
  }, [value, duration]);

  if (display === null) return <>{value ?? '—'}</>;

  const rounded = Number.isInteger(value) ? Math.round(display) : display.toFixed(1);
  return <>{rounded}{suffix}</>;
};

export default CountUp;
